import React from 'react';
import Drawer from '@material-ui/core/Drawer';

const defaultAnchor = 'bottom';

export const BottomSheet = ({ open, actionComponent, children }) => (
  <>
    {actionComponent}
    <Drawer anchor={defaultAnchor} variant="temporary" open={open}>
      <div style={{ height: '100%' }}>{children}</div>
    </Drawer>
  </>
);
